var isFailedStatus = function (response) {
    return !(response === null || response === void 0 ? void 0 : response.status) || (response === null || response === void 0 ? void 0 : response.status) < 200 || (response === null || response === void 0 ? void 0 : response.status) >= 300;
};
export { isFailedStatus };
